import React from "react";
import Input from "uikit/src/components/Input";
import GroupSuggest from "@/views/Admin/Events/Event/Promocodes/GroupSuggest/GroupSuggest";
import PromocodeChips from "./PromocodeChips";
import styles from "../Form.module.scss";
import {FormInterface} from "../Form.interface";
import InputSkeleton from "@/views/Admin/Events/Event/Promocodes/Form/components/InputSkeleton";

interface GroupRowProps {
    isGroup: boolean;
    form: FormInterface;
    setForm: React.Dispatch<React.SetStateAction<FormInterface>>;
    handleChange: (
        fieldName: keyof FormInterface['fields'],
        value: FormInterface['fields'][keyof FormInterface['fields']]['value']
    ) => void;
    undefinedName: string;
}

const GroupRow: React.FC<GroupRowProps> = ({
                                               isGroup,
                                               form,
                                               setForm,
                                               handleChange,
                                               undefinedName,
                                           }) => {
    return (
        <div className={isGroup ? styles.rowGroup : styles.row}>
            {[isGroup, true].map((cond, index) => {
                const isSuggest = isGroup ? index === 0 : index === 1;

                return (
                    <div className={styles.fieldSingle} key={index}>
                        {isSuggest ? form.fields.groupId.isLoading ? (
                            <InputSkeleton size="small" />
                        ) : (
                            <GroupSuggest
                                data-testid="groupId-input"
                                data={form}
                                onChange={setForm}
                            />
                        ) : isGroup ? (
                            <PromocodeChips
                                value={form.fields.promocodes.value}
                                label={form.fields.promocodes.label ?? ''}
                                placeholder={form.fields.promocodes.placeholder ?? ''}
                                error={form.fields.promocodes.error ?? ''}
                                disabled={form.fields.promocodes.isDisabled ?? false}
                                onAdd={(newCodes) => {
                                    setForm(prev => ({
                                        ...prev,
                                        isFormChanged: true,
                                        fields: {
                                            ...prev.fields,
                                            promocodes: {
                                                ...prev.fields.promocodes,
                                                value: [...prev.fields.promocodes.value, ...newCodes],
                                                error: null,
                                                isChanged: true,
                                            }
                                        }
                                    }));
                                }}

                                onRemove={(code) => {
                                    setForm(prev => ({
                                        ...prev,
                                        isFormChanged: true,
                                        fields: {
                                            ...prev.fields,
                                            promocodes: {
                                                ...prev.fields.promocodes,
                                                value: prev.fields.promocodes.value.filter(c => c.code !== code),
                                                error: null,
                                                isChanged: true,
                                            }
                                        }
                                    }));
                                }}
                            />
                        ) : (
                            <Input
                                data-testid="promocode-input"
                                value={form.fields.promocode.value}
                                label={form.fields.promocode.label ?? ''}
                                placeholder={form.fields.promocode.value === '—' ? undefinedName : form.fields.promocode.placeholder ?? ''}
                                error={form.fields.promocode.error ?? ''}
                                disabled={form.fields.promocode.isDisabled ?? false}
                                onChange={({target}) => handleChange('promocode', target.value)}
                                size="small"
                            />
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default GroupRow;
